module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!--  css in staticUCs.css  -->\r\n<span class="table_pieces_jointes"></span>\r\n<span class="file_transfer"></span>';
}
return __p;
};
